import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import { GREAT_WHITE, KOALA, OBSIDIAN } from 'HubStyleTokens/colors';
import { WEB_FONT_DEMI_BOLD_WEIGHT } from 'HubStyleTokens/misc';
import PortalIdParser from 'PortalIdParser';
import UIRouterNavButton from 'ui-addon-react-router-dom/UIRouterNavButton';
import { useIsActiveRoute } from '../../../hooks/useIsActiveRoute';

const makeStyledNavButton = ButtonComponent => styled(ButtonComponent).attrs(() => ({
  use: 'transparent'
})).withConfig({
  displayName: "RouterNavButton__makeStyledNavButton",
  componentId: "sc-3byehg-0"
})(["&&{background-color:", ";border:0;color:", ";font-size:16px;font-weight:", ";&:hover{background-color:", ";color:", ";text-decoration:none;}}"], props => props.active ? KOALA : 'transparent', OBSIDIAN, WEB_FONT_DEMI_BOLD_WEIGHT, GREAT_WHITE, OBSIDIAN);

const StyledNavButton = makeStyledNavButton(UIButton);
const StyledRouterNavButton = makeStyledNavButton(UIRouterNavButton);
export default function RouterNavButton(_ref) {
  let {
    active,
    to,
    exact = false,
    matchEscape
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["active", "to", "exact", "matchEscape"]);

  const isActiveRoute = useIsActiveRoute(to, exact, matchEscape);
  return /*#__PURE__*/_jsx(StyledRouterNavButton, Object.assign({}, rest, {
    active: active || isActiveRoute,
    to: to,
    exact: exact
  }));
}
export function DropdownButton(props) {
  return /*#__PURE__*/_jsx(StyledNavButton, Object.assign({}, props));
}
export function ActiveDropdownButton(props) {
  return /*#__PURE__*/_jsx(StyledNavButton, Object.assign({}, props, {
    active: true
  }));
}

function toNavPath(goodSubType) {
  return `/marketplace/${PortalIdParser.get()}/products?subType=${goodSubType}`;
}

export function LegacyNavButton(_ref2) {
  let {
    goodSubType
  } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, ["goodSubType"]);

  return /*#__PURE__*/_jsx(StyledNavButton, Object.assign({
    href: toNavPath(goodSubType)
  }, rest));
}